// extracted by mini-css-extract-plugin
module.exports = {"content":"Contacts_content__1lFf7","contactsBlock":"Contacts_contactsBlock__3bWcl","contactsColumn":"Contacts_contactsColumn__1Sqr2"};